<!-- 数据字典管理-字典详情 -->
<template>
<div>
  <Table
    ref="table"
    :loadObj='{}'
    :option="{}"
    :colObj='{
      opId:"106",
      name:"字典详情",
      parentId:"DICT_ID",
      parentName:"数据字典管理",
      parentPath:"/system/dataDictionary",
      dataClass:2,
      col:[]
    }'
  >
  </Table>
</div>
</template>

<script>
import Table from '@/components/table/dataTablecSon';
import {processDeal} from '@/api/home/home';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
    // 顶部新增数据实体
    addBtnClick(){
      processDeal({obj:JSON.stringify({id:8,tablename:this.$route.query.tableName,appendflag:1})}).then(res=>{
        this.$refs.table.$refs.child.onLoad();
        this.$message.success("新增成功!");
      },err=>{})
    },
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
